// import React , {useState } from 'react';
import { Link } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';
// import { useAuth } from '../AuthContext';
// import Header from './Header';

import NewsletterSignup from './NewsletterSignUp';
import Testimonials from './Testimonials';
import PastEvents from '../pages/PastEvents';
// import UpcomingEvent from '../pages/UpcomingEvent';
import LatestBlogPosts from '../pages/Blog';
// import Header from './Header';
import Paris from '../assets/images/slider/paris.jpeg';
import Barcelona from '../assets/images/slider/barcelona.jpeg';
import Kingston from '../assets/images/slider/kingston.jpg';
import Haiti  from '../assets/images/slider/haiti.jpeg';
import Bahamas from '../assets/images/slider/bahamas.png';
import London from '../assets/images/slider/london.png';

import colors from '../theme';

import Community from '../pages/Community';

import FlagBanner from './FlagBanner';
import '../custom.css';
import { useEffect } from 'react';



function Home() {

  // const { currentUser } = useAuth();
  // const { logout } = useAuth();
  // const [preferencesSaved, setPreferencesSaved] = useState(false);
  // const history = useHistory();
  //Custom title of the page



// Hero style
// const heroStyle = {
//   backgroundImage: 'url("https://unieros.com/wp/wp-content/uploads/2022/08/dance_party-scaled.jpg")',
//   backgroundSize: 'cover',
//   backgroundPosition: 'center center',
//   minHeight: '80vh',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   color: '#fff',
//   opacity: '0.9',
// };
//Create a carousel of multiple images the user can scroll through
const carouselImages = [
  {
    src: `https://unieros.com/wp/wp-content/uploads/2022/08/dance_party-scaled.jpg`,
    alt: 'Paris',
    caption: 'Unieros Event - One Love, Many Cultures',
  },
 
  {
    src: `${Paris}`,
    alt: 'Paris',
    caption: 'The Moulin Rouge, Paris',
  },
  {
    src: `${Haiti}`,
    alt: 'Haiti',
    caption: 'Little Haiti Cultural Center, Miami',
  },
  {
    src: `${Barcelona}`,
    alt: 'Barcelona',
    caption: 'Park Guell, Barcelona, Spain',

  },
  {
    src: `${Kingston}`,
    alt: 'Kingston',
    caption: 'Bob Marley Day, Kingston Jamaica',
  },
  {
    src: `${Bahamas}`,
    alt: 'Bahamas',
    caption: 'Goombay Festival Little Bahamas, Miami',
  },
  {src: `${London}`,
  alt: 'London',
  caption: 'Covent Gardens mural, London',
}
];
const carouselStyle = {
  height: '300px', // Set fixed height for carousel
  marginBottom: '20px',
  
};

useEffect(() => {
  document.title = 'Unieros - One Love, Many Cultures';
  // const carousel = document.querySelector('.carousel');
//   const carouselInstance = new window.bootstrap.Carousel(carousel, {
//     interval: 5000, // Change image every 5 seconds
//   });
}, []);

//saved preferences
  // const handlePreferencesSaved = () => {
  //   setPreferencesSaved(true);
  // };

  // const showPreferencesForm = () => {
  //   setPreferencesSaved(false);
  // };

  //Logout
  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     // setIsLoggedIn(false);
  //   } catch (error) {
  //     console.error('Failed to log out:', error);
  //   }
  // };

    return (

      <div className="homepage">
    
        <div className="row">
           <section className=" carousel slide mb-6" data-bs-ride="carousel" style={carouselStyle}>
           <div className="carousel-inner">
        {carouselImages.map((image, index) => (
          <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
            <img
              src={image.src}
              alt={image.alt}
              className="d-block w-100 h-100"
              style={{ objectFit: 'cover', maxWidth: '100%', maxHeight: `${carouselStyle.height}`}} // Crop image to fit fixed height
            />
            <div className="carousel-caption d-none d-md-block">
              <h5>{image.caption}</h5>
              </div>
          </div>
        ))}
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target=".carousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target=".carousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </section>
    </div>
    <div className="row">
          <section className="text-center">
            <div className="container">
            <h2> Explore, connect, celebrate diversity</h2>
            </div>
            </section>
  </div>
  <div className="row mb-3">
         <FlagBanner />
  </div>
      {/* <section className="mt-2 mb-5"> 
      <div className="container">
      <h2 className="text-center mb-4 display-3">Latest Podcast</h2>
      <p className="lead">
        In this episode, we talk to Star Djeene, a African raised in Germany. She shares her experience growing up in Germany and how she navigates her dual identity in a diverse world. 
      </p>
      <p className="shadow p-3 mb-5 bg-body-tertiary rounded">
        <a href="https://www.unieros.com/wp/podcast/both-african-and-german-heritage"><img src="https://unieros.com/wp/wp-content/uploads/2023/09/StarDjeene.jpeg" alt="Unieros Podcast cover art Star Djeene" className="img-fluid" /> </a>
</p>
      </div>
      </section> */}
    
     {/* Login form */}
        {/* <section className="mt-5">
        <div>
          {!currentUser && (
            <LoginForm onLoggedIn={() => {}} />
          )}
          {currentUser && (
            <p>
              You are now logged in!{' '}
              <Link to="/profile" component={Profile}> Click here to update your profile.</Link>
            </p>
          )}
        </div>
        <div>  
        {currentUser && (
          <div>
            <button onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
            </div>
      </section>
      */}
          {/* Newsletter Signup */ }
          
          <div className="row">
          <section className="newsletter-signup">
      <div className="container">   
          <NewsletterSignup /> 
      </div>
      </section>
      </div>
    
    
     { /* Upcoming event */ }
        <section>
        <div className="container">
    
   <Community />

<div className="row" >
 
  <div style={{ backgroundColor: colors.warmGold, color: colors.neutralGray }} className="mb-4">
 <p className="lead">Unieros Digital Services the 41st International Reggae and World Music Awards
  </p>
  <p>Unieros Digital Services is a new offering took stage as the official social media and digital marketing technical support of the 41st International Reggae and World Music Awards (IRAWMA).For this collaboration, Unieros is providing innovative digital solutions for IRAWMA.</p>
  <p><Link to="/blog" className="btn btn-unieros"> Read more </Link></p>

 </div>
        </div>
        <div className="row">
          <h2 className="display-6">Shop</h2>
          <img src="https://unieros.com/wp/wp-content/uploads/2023/12/mens-t-shirt-regular-black-front.png" alt="Unieros Caribbean Tshirt" className="img-fluid" />
          <p>Get Unieros cultural inspired swag from our cultural canvas online store</p>
          <p><a href="https://unieros.threadless.com/" className="btn btn-unieros">Browse Shop</a></p>
        </div>

     
    </div>

        </section>
      
    
      
      {/* Testimonials */}
      <section className="testimonials py-5">
        <div className="container">
          <Testimonials />
        </div>
      </section>

      {/* Past Events */}
      <section className="past-events py-5">
        <div className="container">
          <PastEvents />
        </div>
      </section>

      {/* Latest Blog Posts */}
      <section className="latest-blog-posts py-5">
        <div className="container">
          <LatestBlogPosts />
        </div>
      </section>
      </div> 
      
    );
  };

  export default Home;
  